<template>
  <base-modal size="lg" hide-footer hide-header @close="$emit('close')">
    <div class="col-12">
        <div class="col-12" style="height: 70vh; position: relative; overflow: hidden">
          <map-container
            ref="map"
            :lat="coordinate ? coordinate.lat : 62.7"
            :lon="coordinate ? coordinate.lng : 25.2"
            :center="mapCenter"
            @on-map-clicked="mapClicked"
            @on-drag-end="onDragEnd"
            @on-map-changed="onMapChanged"
          />
          <div class="map-see-through-container ps-1 pb-1 pe-1">
            <div class="col" style="width: 3em">
              <div
                v-if="!observationMode || observationMode && savedGeometry.point"
                class="draw-button-row"
              >
                <button
                  class="btn btn-dark draw-button mb-1"
                  :disabled="addPointEnabled"
                  @click.stop="setEnabledFeature('point')"
                >
                  <font-awesome-icon icon="map-pin" class="text-light"/>
                  <div class="btn-text">
                    {{ $t('common.point') }}
                  </div>
                </button>
              </div>
              <div
                v-if="!observationMode || observationMode && savedGeometry.line_string"
                class="draw-button-row"
              >
                <button
                  class="btn btn-dark draw-button mb-1"
                  :disabled="addPolylineEnabled"
                  @click.stop="setEnabledFeature('polyline')"
                >
                  <img
                    src="@/assets/draw_multiline.svg"
                    style="width: 1em; height: 1em;"
                    alt="Draw multiline"
                  >
                  <div class="btn-text">
                    {{ $t('common.line') }}
                  </div>
                </button>
              </div>
              <div
                v-if="!observationMode"
                class="draw-button-row"
              >
                <button
                  :disabled="addPolygonEnabled"
                  class="btn btn-dark draw-button mb-1"
                  @click.stop="setEnabledFeature('polygon')"
                >
                  <font-awesome-icon icon="draw-polygon" class="text-light" />
                  <div class="btn-text">
                    {{ $t('common.area') }}
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 button-container pt-2 pb-0 mb-0">
          <button
            class="btn btn-sm btn-secondary form-button"
            @click.stop="$emit('close')"
          >
            {{ $t('common.cancel') }}
          </button>
          <button
            class="btn btn-outline-info btn-sm form-button"
            :disabled="!drawnFigure"
            @click.stop="undoLastEdit(type)"
          >
            {{ $t('common.undo') }}
          </button>
          <button
            class="btn btn-sm btn-success form-button"
            :disabled="!drawnFigure"
            @click.stop="saveFeature"
          >
            {{ $t('common.save') }}
          </button>
        </div>

        <base-modal
          v-if="showConfirmRemoveFeature"
          size="sm"
          centered
          ok-variant="success"
          :hide-header="true"
          :cancel-title="$t('common.cancel')"
          :ok-title="$t('common.continue')"
          @ok="continueRemoveFeature(type)"
          @close="cancelRemoveFeature()"
        >
          <div class="modal-body">
            <span>{{ $t('map.remove_drawn_geometry') }}</span>
          </div>
        </base-modal>
    </div>

  </base-modal>
</template>

<script>

import BaseModal from '../BaseModal'
import {geometryMixin} from '../mixins/GeometryMixin'
import {mapHelper} from '../mixins/MapMixin'
import {restApi} from '../mixins/RestApiMixin'
import MapContainer from "../map/MapContainer";
import {measureDistanceMixin} from "../mixins/MeasureDistanceMixin";

export default {
    name: "DrawGeometryWizard",
    components: {MapContainer, BaseModal},
    mixins: [
        mapHelper,
        restApi,
        measureDistanceMixin,
        geometryMixin
    ],
    props: {
        type: {
            type: Number,
            required: true
        },
        coordinate: {
            type: Object,
            default: null
        },
        user: {
            type: Object,
            default: null
        },
        observationMode: {
            type: Boolean,
            default: false
        },
        savedGeometry: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            geometry: null,
            drawnFigure: false,
            addPolygonEnabled: false,
            addPolylineEnabled: false,
            addPointEnabled: true,
            map: null,
            mapCenter: null,
            newPolygonId: -1,
            newPolyLineId: -1,
            newPointId: -1,
            polylinePoints: [],
            activeFeature: "",
            newFeature: "",
            removeFeature: true,
            showConfirmRemoveFeature: false,
        }
    },
    emits: ['close', 'addDrawnGeometry'],
    mounted: function () {
        if(this.savedGeometry && this.savedGeometry.geometry) {
            this.mapCenter = this.savedGeometry.geometry.point
        } else if(this.getMapSettingsIn(['center'])){
            this.mapCenter = this.getMapSettingsIn(['center'])
        } else if (this.user && this.user.company.location) {
            this.mapCenter = {
                lon: this.user.company.location.x,
                lat: this.user.company.location.y,
            }
        } else if (this.center) {
            this.mapCenter = this.center
        }
    },
    methods: {
        onMapChanged(map) {
            this.map = map;
            if(this.savedGeometry){
                this.geometry = this.savedGeometry
                this.drawExistingFeature(this.map.getMarkerStore(), this.type)
                this.$nextTick(() => this.map.zoomToGroup(this.type))
            }
            else {
                this.map.zoomToPosition(this.mapCenter.lat, this.mapCenter.lng)
            }
        },
        onDragEnd(coord) {
            if(coord && coord.position) {
                const coordConversion = {lat: coord.position.y, lng: coord.position.x}
                if (this.newPointId > 0) {
                    this.geometry = coordConversion
                } else {
                    this.addPoints(this.type, coordConversion)
                }
            }
        },
        mapClicked: function (coord) {
            if (this.newPointId < 0) {
                this.addPoints(this.type, coord)
            }
        },
        saveFeature() {
            if (!this.addFeatureToAssignment()) {
                this.$emit('close')
            }
        }
    }
}

</script>

<style>
@import "../../styles/modal.css";
.map-see-through-container {
    padding-top: 1em;
    background: rgba(255, 255, 255, 0);
    z-index: 2;
    position: relative;
    width: fit-content;
}
.draw-button{
    min-width: 3.5em;
}
.draw-button-row{
    width: inherit;
}
.btn-text {
    font-size: .7em;
    font-weight: bold;
    color: #FFFFFF;
}
</style>
